import { render } from "./chat.vue?vue&type=template&id=972f6960&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=972f6960&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972f6960"]])

export default __exports__